<div class="container mt-5" *ngIf="errorMsg">
    <section class="row">
        <div class="col-sm-10 col-md-10  col-lg-7 col-xl-4 horizontal-center">
            <ngb-alert  [type]="'danger'" [dismissible]="false">
                <strong>Server Error</strong> {{errorMsg}}
            </ngb-alert>
            
        </div>
    </section>
</div>
<section>
    <gt-app-loader></gt-app-loader>
</section>
